import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineArrowLeft } from 'react-icons/hi2';
import { workPermitService } from '../services';
import PageLoading from '../components/common/PageLoading';
import './Reports.css';

const WorkPermitComplianceReport = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadData = async () => {
    try {
      setLoading(true);
      setError('');
      const rows = await workPermitService.getWorkPermits();
      setData(rows || []);
    } catch (err) {
      console.error(err);
      setError('Failed to load permits.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const metrics = useMemo(() => {
    if (!data.length) return { total: 0, closed: 0, cancelled: 0, closedOnTime: 0, onTimePct: 0 };
    const total = data.length;
    const closed = data.filter((p) => p.status === 'Closed').length;
    const cancelled = data.filter((p) => p.status === 'Cancelled').length;
    const closedOnTime = data.filter((p) => {
      if (p.status !== 'Closed' || !p.validTo || !p.closedDate) return false;
      return new Date(p.closedDate) <= new Date(p.validTo);
    }).length;
    const onTimePct = closed ? Math.round((closedOnTime / closed) * 100) : 0;
    return { total, closed, cancelled, closedOnTime, onTimePct };
  }, [data]);

  return (
    <div className="pagecontainer reports-page">
      <div className="page-header">
        <div className="header-content">
          <div className="report-title-section">
            <button className="back-btn" onClick={() => navigate("/home/reports")} title="Back to Reports Dashboard">
              <HiOutlineArrowLeft />
            </button>
            <h1>Work Permit Compliance Report</h1>
          </div>
          <p>Closure and cancellation overview.</p>
        </div>
        <div className="reports-actions">
          <button className="btn-secondary" onClick={loadData}>Refresh</button>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}
      {loading ? (
        <PageLoading message="Loading report…" />
      ) : (
        <div className="reports-grid  workreport-metrics">
          <div className="report-card">
            <div className="report-card-label">Totals</div>
            <div className="report-card-value">Total: {metrics.total}</div>
            <div className="report-card-value">Closed: {metrics.closed}</div>
            <div className="report-card-value">Cancelled: {metrics.cancelled}</div>
          </div>
          <div className="report-card">
            <div className="report-card-label">On-Time Closure</div>
            <div className="report-card-value">{metrics.onTimePct}%</div>
            <div className="report-card-note">Closed on/before validity end</div>
          </div>
          <div className="report-card">
            <div className="report-card-label">Closed On Time (count)</div>
            <div className="report-card-value">{metrics.closedOnTime}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkPermitComplianceReport;

